import { useEffect, useState } from "react";
import { Box, Typography, Grid, Avatar, Divider, Tooltip, Chip, Rating, InputLabel, FormControl, Select, MenuItem } from "@mui/material";
import { useHistory, useParams, useLocation } from "react-router-dom";
import ReusableHeadingComponents from "../../components/reusableComponents/reusableHeadingComponents";
import CustomTabs from "../../components/reusableComponents/CustomTabs";
import ReusableChip from "../../components/reusableComponents/chipSelector";
import ReusableButton from "../../components/reusableComponents/reusableButtonComponents";
import ReusableMuiIcons from "../../_helpers/ReusableMuiIcons";
import ApiService from "../../_services/ApiService";
import fetchApplications from "../../_helpers/reusablefunctions/fetchApplication";
import TabsApplicationData from "./tabsApplicationData";
import useSnackDispatcher from "../../_helpers/reusablefunctions/snackBarComponent";
import BrandRatingPage from "./BrandRatingPage"
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";

const tabs = ["pitch", "shipping", "deliverable", "livepost"];
const tabLabels = {
    pitch: "Pitch",
    shipping: "Shipping Status",
    deliverable: "Deliverables Status",
    livepost: "Live Post Status",
};

const disabledReasons = {
    shipping: "Agreement is not approved yet",
    deliverable: 'Shipping is not delivered & deliverable link is not approved by creator',
    livepost: 'livepost link is not approved by creator'
}


export default function ViewApplication() {
    const history = useHistory();
    const location = useLocation();
    const { tabName, offerId } = useParams();
    const [activeTab, setActiveTab] = useState(tabName || "pitch");
    const [brand, setBrand] = useState('');

    const [trackingLink, setTrackingLink] = useState('');
    const [selectedShippingStatus, setSelectedShippingStatus] = useState('');
    const [showFeedbackBox, setShowFeedbackBox] = useState(false);
    const [feedbackText, setFeedbackText] = useState('');
    const [feedbackSentIndexes, setFeedbackSentIndexes] = useState([]);
    const [expandedIndexes, setExpandedIndexes] = useState([]);
    const [submittedFeedbackTexts, setSubmittedFeedbackTexts] = useState({});
    const [applicationData, setApplicationData] = useState(null);
    const [isValidMap, setIsValidMap] = useState({});
    const [reasonMap, setReasonMap] = useState({});
    const [activeTabs, setActiveTabs] = useState('Submission');
    const [loading, setLoading] = useState({
        approvePitch: false,
        rejectPitch: false,
        approveDeliverable: false,
        rejectDeliverable: false,
        requestChanges: false,
        sendFeedback: false,
        shipping: false,
        save: false,
        markAsClosed: false
    });
    const [rejectFeedbackText, setRejectFeedbackText] = useState("");
    const [showRejectFeedbackBox, setShowRejectFeedbackBox] = useState(false);
    const [handles, setHandles] = useState([]);
    const [selectedHandle, setSelectedHandle] = useState("");
    const [handleRating, setHandleRating] = useState("");
    const queryParams = new URLSearchParams(location.search);
    const campaignType = queryParams.get("campaign_type");
    const CreatorId = queryParams.get("creator_id");
    const handle = queryParams.get("handle");
    const [loadingMap, setLoadingMap] = useState({});

    const { successSnack, errorSnack } = useSnackDispatcher();
    const niches = applicationData?.creator_handle_niche && applicationData.creator_handle_niche.trim() !== ""
        ? applicationData.creator_handle_niche
            .split(",")
            .map((n) => n.trim())
            .filter((n) => n.length > 0)
        : [];

    const visibleNiches = niches.slice(0, 3);
    const hiddenNiches = niches.slice(3);

    const getPlatformIcon = (type) => {
        switch (type.toLowerCase()) {
            case "instagram":
                return <InstagramIcon fontSize="small" sx={{ color: "#E1306C", mr: 1 }} />;
            case "youtube":
                return <YouTubeIcon fontSize="small" sx={{ color: "red", mr: 1 }} />;
            default:
                return null;
        }
    };

    const fetchHandles = async () => {
        try {
            const params = {
                campaign_id: offerId,
                campaign_type: campaignType,
                creator_id: CreatorId
            };

            const res = await ApiService.get("get_all_handles", params);
            if (res?.status === 200 && res?.data?.handles) {
                setHandles(res.data.handles);

                if (handle) {
                    const found = res.data.handles.find(h => String(h.creator_handle_id) === String(handle));
                    if (found) {
                        setSelectedHandle(found.creator_handle_id);
                        // loadHandler(found.creator_handle_id);
                    }
                } else if (!selectedHandle && res.data.handles.length > 0) {
                    setSelectedHandle(res.data.handles[0].creator_handle_id);
                    // loadHandler(res.data.handles[0].creator_handle_id);
                }
            } else {
                setHandles([]);
            }
        } catch (error) {
            console.error("Failed to fetch handles:", error);
            setHandles([]);
        }
    };

    useEffect(() => {
        if (offerId && CreatorId && campaignType) {
            fetchHandles();
        }
    }, [offerId, CreatorId, campaignType]);

    useEffect(() => {
        if (campaignType && offerId) {
            loadHandler(handle);
        }
    }, [location.search]);

    const loadHandler = async (handleValue) => {
        const params = { campaign_type: campaignType, campaign_id: offerId };
        if (handleValue) {
            params.handle = handleValue;
        }

        try {
            const res = await ApiService.get("get_submission_handles", params);
            if (res?.status == 200 || res?.status == 201) {
                setApplicationData(res?.data?.results?.[0])
            }
        } catch (error) {
            console.error("Error loading submission handles:", error);
        }
    }

    const handleHandleChange = (event) => {
        const selectedId = event.target.value;
        setSelectedHandle(selectedId);

        history.push(
            `/view-application/${offerId}/${tabName}?creator_id=${CreatorId}&campaign_type=${campaignType}&handle=${selectedId}`
        );
    };

    const handleSave = async (id, isValidOverride) => {
        // setLoading(prev => ({ ...prev, save: true }));
        setLoadingMap(prev => ({ ...prev, [id]: true }));
        try {
            const isValid = isValidOverride || isValidMap[id];
            const reason = reasonMap[id] || '';
            const submissionId = applicationData?.id;
            const parentLinks = applicationData?.live_links || [];
            const parentLinkObj = parentLinks.find(link => link.id === id || link.child?.id === id);
            const isSubmissionTab = activeTabs === 'Submission';
            const targetLink = isSubmissionTab ? parentLinkObj : parentLinkObj.child;
            let link_status = "";

            if (isValid === "Yes") {
                link_status = "Approved";
            } else if (isValid === "No") {
                link_status = isSubmissionTab ? "Need-changes" : "Rejected";
            }

            const payload = {
                submission: submissionId,
                link_status,
                link_reason: reason,
            };

            const targetId = targetLink.id;

            const response = await ApiService.put("live_links", payload, null, targetId);
            if (response.status === 200) {
                successSnack(`Link ${link_status}`);
                const { list, count } = await fetchApplications(offerId);
                const updatedApp = list.find(app => app.id === submissionId);
                if (updatedApp) {
                    setApplicationData(updatedApp);
                }
            } else {
                errorSnack("Failed to update live link status.");
            }
        } catch (err) {
            console.error("Live link update failed:", err);
            errorSnack("Something went wrong.");
        } finally {
            // setLoading(prev => ({ ...prev, save: false }));
            setLoadingMap(prev => ({ ...prev, [id]: false }));
        }
    };

    const updateDeliverableStatus = async ({ deliverableId, status, reason }) => {
        try {
            const payload = {
                submission: applicationData?.id,
                deliverable_status: status,
                deliverable_reason: reason || "",
            };

            const response = await ApiService.put('deliverable_links', payload, null, deliverableId);

            if (response.status === 200) {
                const { list, count } = await fetchApplications(offerId);
                const updatedApp = list.find(app => app.id === applicationData?.id);
                if (updatedApp) {
                    setApplicationData(updatedApp);
                }
                successSnack(`Deliverable ${status}`);
            }
        } catch (error) {
            console.error("Deliverable Update Failed:", error);
            errorSnack("Something went wrong while updating deliverable.");
        }
    };

    const handleApproveDeliverable = async (submissionIndex) => {
        setLoading(prev => ({ ...prev, approveDeliverable: true }));
        try {
            const parentDeliverable = applicationData?.deliverables_links?.[0];
            const childDeliverable = parentDeliverable?.child;

            let deliverableIdToApprove = null;

            if (submissionIndex === 0 && parentDeliverable?.id) {
                deliverableIdToApprove = parentDeliverable.id;
            } else if (submissionIndex === 1 && childDeliverable?.id) {
                deliverableIdToApprove = childDeliverable.id;
            }

            if (deliverableIdToApprove) {
                await updateDeliverableStatus({
                    deliverableId: deliverableIdToApprove,
                    status: "Approved",
                });

                setActiveTab("livepost");
                history.push(`/view-application/${offerId}/livepost?creator_id=${CreatorId}&campaign_type=${campaignType}&handle=${handle}`);
            }
        } catch (error) {
            console.error('Error approving deliverable:', error);
            errorSnack("Failed to approve deliverable");
        } finally {
            setLoading(prev => ({ ...prev, approveDeliverable: false }));
        }
    };

    const handleRejectDeliverable = async (index) => {
        setLoading(prev => ({ ...prev, rejectDeliverable: true }));
        try {
            const childDeliverable = applicationData?.deliverables_links?.[0]?.child;
            if (childDeliverable?.id) {
                await updateDeliverableStatus({
                    deliverableId: childDeliverable.id,
                    status: "Rejected",
                    reason: rejectFeedbackText,
                });

                setShowRejectFeedbackBox(false);
                setRejectFeedbackText("");
            }
        } catch (error) {
            console.error('Error rejecting deliverable:', error);
            errorSnack("Failed to reject deliverable");
        } finally {
            setLoading(prev => ({ ...prev, rejectDeliverable: false }));
        }
    };

    const handleSendFeedback = async (index) => {
        setLoading(prev => ({ ...prev, sendFeedback: true }));
        try {
            const parentDeliverable = applicationData?.deliverables_links?.[0];
            if (parentDeliverable?.id) {
                await updateDeliverableStatus({
                    deliverableId: parentDeliverable.id,
                    status: "Need-changes",
                    reason: feedbackText,
                });

                setShowFeedbackBox(false);
                setFeedbackText('');
                setFeedbackSentIndexes(prev => [...prev, index]);
                setSubmittedFeedbackTexts(prev => ({
                    ...prev,
                    [index]: feedbackText,
                }));
            }
        } catch (error) {
            console.error('Error sending feedback:', error);
            errorSnack("Failed to send feedback");
        } finally {
            setLoading(prev => ({ ...prev, sendFeedback: false }));
        }
    };

    const getEnabledTabs = () => {
        const enabledTabs = ["pitch"];

        if (applicationData?.status === "Approved") {
            enabledTabs.push("shipping");
        }

        const parentDeliverable = applicationData?.deliverables_links?.[0];
        const childDeliverable = parentDeliverable?.child;

        const hasDeliverableLink =
            parentDeliverable?.deliverable_link || childDeliverable?.deliverable_link;

        if (
            // applicationData?.shipping_status?.includes("Delivered") &&
            applicationData?.is_delivered === true &&
            hasDeliverableLink
        ) {
            enabledTabs.push("deliverable");
        }

        const isLivePostValid =
            (applicationData?.deliverables_links || []).some(dl => {
                const parentApproved = dl?.deliverable_status === "Approved";
                const childApproved = dl?.child?.deliverable_status === "Approved";
                return parentApproved || childApproved;
            });

        if (isLivePostValid && applicationData?.live_links?.length > 0) {
            enabledTabs.push("livepost");
        }

        return enabledTabs;
    };

    const UpdateSubmission = async (payload) => {
        try {
            const response = await ApiService.put('update_submission', payload, { id: applicationData?.id });
            if (response.status === 200) {
                const { list, count } = await fetchApplications(offerId);
                const updatedApp = list.find(app => app.id === applicationData?.id);
                if (updatedApp) {
                    setApplicationData(updatedApp);
                }
            }
        } catch (error) {
            console.error('API Error:', error);
        }
    };

    useEffect(() => {
        if (applicationData?.tracking_link) {
            setTrackingLink(applicationData.tracking_link);
        }
        if (applicationData?.shipping_status) {
            setSelectedShippingStatus(applicationData.shipping_status.trim());
        }
        if (applicationData?.feedback) {
            setFeedbackSentIndexes([0]);
            setSubmittedFeedbackTexts({ 0: applicationData.feedback });
            setExpandedIndexes([0]);
        }
    }, [applicationData]);

    const handleApprovePitch = async () => {
        setLoading(prev => ({ ...prev, approvePitch: true }));
        try {
            const payload = { status: "Approved" };
            await UpdateSubmission(payload);
            setActiveTab("shipping");
            history.push(`/view-application/${offerId}/shipping?creator_id=${CreatorId}&campaign_type=${campaignType}&handle=${handle}`);
            successSnack("Approved the pitch");
        } catch (error) {
            console.error('Error approving pitch:', error);
            errorSnack("Failed to approve pitch");
        } finally {
            setLoading(prev => ({ ...prev, approvePitch: false }));
        }
    };

    const handleRejectPitch = async (selectedReasons, otherMessage) => {
        setLoading(prev => ({ ...prev, rejectPitch: true }));
        try {
            const payload = {
                status: "Rejected",
                rejection_reasons: selectedReasons || "",
                other_message: otherMessage || ""
            };
            await UpdateSubmission(payload);
            errorSnack("Rejected the pitch");
        } catch (error) {
            console.error('Error rejecting pitch:', error);
            errorSnack("Failed to reject pitch");
        } finally {
            setLoading(prev => ({ ...prev, rejectPitch: false }));
        }
    };

    const handleShippingStatusChange = (status) => {
        setSelectedShippingStatus(prev => (prev === status ? '' : status));
    };

    const handleShippingSubmit = async () => {
        setLoading(prev => ({ ...prev, shipping: true }));
        try {
            const payload = {
                tracking_link: trackingLink,
                shipping_status: selectedShippingStatus
            };
            await UpdateSubmission(payload);

            if (selectedShippingStatus.includes("Delivered")) {
                setActiveTab("deliverable");
                history.push(`/view-application/${offerId}/deliverable?creator_id=${CreatorId}&campaign_type=${campaignType}&handle=${handle}`);
            }
            const hasDeliveryFailed = selectedShippingStatus.includes("Delivery Failed");
            const validStatus = ["Shipped", "In Transit", "Delivered"].find(status =>
                selectedShippingStatus.includes(status)
            );

            if (hasDeliveryFailed) {
                errorSnack("Delivery Failed");
            } else if (validStatus) {
                successSnack(validStatus);
            }
        } catch (error) {
            console.error('Error updating shipping:', error);
            errorSnack("Failed to update shipping status");
        } finally {
            setLoading(prev => ({ ...prev, shipping: false }));
        }
    };

    const handleRequestChangesClick = () => {
        setShowFeedbackBox(true);
    };

    useEffect(() => {
        if (tabName) {
            const enabledTabs = getEnabledTabs();
            if (enabledTabs.includes(tabName)) {
                setActiveTab(tabName);
            } else {
                setActiveTab(enabledTabs[enabledTabs.length - 1]);
            }
        }
    }, [tabName, applicationData]);

    const handleTabChange = (newTab) => {
        const enabledTabs = getEnabledTabs();
        if (enabledTabs.includes(newTab)) {
            setActiveTab(newTab);
            history.push(`/view-application/${offerId}/${newTab}?creator_id=${CreatorId}&campaign_type=${campaignType}&handle=${handle}`);
        }
    };

    const handleBack = () => {
        if (
            applicationData?.live_status === "Approved" &&
            applicationData?.closed !== true
        ) {
             const confirmed = window.confirm(
            "The live post is approved! Please remember to mark this offer as closed.\n\nDo you still want to go back?"
        );
        if (!confirmed) {
            return; 
        }
        }
        history.push(`/view-offer/${offerId}/application`);
    };

    const toggleExpand = (index) => {
        setExpandedIndexes((prev) =>
            prev.includes(index)
                ? prev.filter((i) => i !== index)
                : [...prev, index]
        );
    };

    const formatDateTime = (isoString) => {
        if (!isoString) return "";
        const date = new Date(isoString);

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");

        return `${day}/${month}/${year} | ${hours}:${minutes}`;
    };

    const formatDate = (isoDate) => {
        if (!isoDate) return "";
        const date = new Date(isoDate);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const enabledTabs = getEnabledTabs();

    const canBeClosed =
        applicationData?.status === "Approved" &&
        applicationData?.shipping_status?.includes("Delivered") &&
        applicationData?.deliverables_status === "Approved" &&
        applicationData?.live_status === "Approved"

    const handleMarkAsClosed = async () => {
        setLoading(prev => ({ ...prev, markAsClosed: true }));
        const payload = { closed: true };

        try {
            await UpdateSubmission(payload);

            const { list, count } = await fetchApplications(offerId);
            const updatedApp = list.find(app => app.id === applicationData?.id);
            if (updatedApp) {
                setApplicationData(updatedApp);
            }

            successSnack("Offer marked as closed");
        } catch (error) {
            console.error("Error marking as closed:", error);
            errorSnack("Failed to mark as closed");
        } finally {
            setLoading(prev => ({ ...prev, markAsClosed: false }));
        }
    };

    const formatFollowers = (num) => {
        if (num === null || num === undefined) return "";
        if (num >= 1_000_000) return (num / 1_000_000).toFixed(1).replace(/\.0$/, "") + "m";
        if (num >= 1_000) return (num / 1_000).toFixed(1).replace(/\.0$/, "") + "k";
        return num.toString();
    };

    const rejectMessage = (stepName, rejection_reasons, other_message) => {
        let reasonsText = "";

        if (Array.isArray(rejection_reasons)) {
            reasonsText = rejection_reasons
                .filter(r => r && r.trim())
                .join(", ");
        } else if (typeof rejection_reasons === "string") {
            reasonsText = rejection_reasons.trim();
        }

        const hasReason = Boolean(reasonsText);
        const hasOther = Boolean(other_message?.trim());

        if (!hasReason && !hasOther) return null;

        return (
            <Box p={2} mt={2} display="flex" flexDirection="row" sx={{ background: '#ffffff', borderRadius: 2 }}>
                <Box p={2} display="flex" flexDirection="row" gap={1} alignItems="center" sx={{ background: '#FBF5F5', width: '100%', borderRadius: 2 }}>
                    <ReusableMuiIcons name='cancel' sx={{ color: '#FF4D49', fontSize: '24px' }} />
                    <Box sx={{ display: "flex", flexDirection: 'column', gap: 0.25 }}>
                        <Typography sx={{ color: "#4C4E64", fontSize: '18px', fontWeight: 600 }}>
                            {stepName} Rejected
                        </Typography>

                        {hasReason && (
                            <Typography component="div" sx={{ color: "#141414B2", fontSize: '12px', fontWeight: 400 }}>
                                {reasonsText}
                            </Typography>
                        )}

                        {hasOther && (
                            <Typography sx={{ color: "#141414B2", fontSize: '12px', fontWeight: 400 }}>
                                {other_message}
                            </Typography>
                        )}
                    </Box>
                </Box>
            </Box>
        );
    };

    const closeMessage = () => {
        return (
            <Box p={2} mt={2} display={"flex"} flexDirection={"column"} sx={{ background: '#ffffff', borderRadius: 2 }} justifyContent={'center'} alignItems={"center"} gap={1.5}>
                <Box display={"flex"} flexDirection={"row"} gap={1} justifyContent={'center'} sx={{ background: '#F6FFFD', borderRadius: 2, p: 3, width: { md: '804px', xs: '100%' } }}>
                    <ReusableMuiIcons name={"clear"} sx={{ color: '#FF4D49', fontSize: '24px' }} />
                    <Typography sx={{ fontSize: '16px', fontWeight: 500, color: "#141414B2" }}>This offer is closed. You can explore other available offers.</Typography>
                </Box>
                <Box display={"flex"} justifyContent={'center'} textAlign={"center"} sx={{ background: '#F8F8F8', padding: '8px 16px', borderRadius: 2, width: { md: '650px', xs: '100%' } }}>
                    <Typography sx={{ color: "#141414B2", fontSize: '14px' }}>You can no longer submit or update your application for this offer.</Typography>
                </Box>
            </Box>
        )
    }

    useEffect(() => {
        const getHandleRating = async () => {
            try {
                const res = await ApiService.get("get_handle_rating", { handle: applicationData?.creator_handle_id });
                setHandleRating(res?.data?.average_rating);
            } catch (error) {
                console.error("Error fetching handle rating:", error);
            }
        };

        if (applicationData?.creator_handle_id) {
            getHandleRating();
        }
    }, [applicationData?.creator_handle_id]);

    return (
        <Box p={4}>
            <Box display={"flex"} justifyContent={"space-between"}>
                <ReusableHeadingComponents
                    bacHistory
                    clickHandlerBack={handleBack}
                    heading={`Influencer Application – ${applicationData?.creator_name} (${applicationData?.creator_agency_id})`}
                    subHeading={`Applied on ${formatDate(applicationData?.applied_at)}`}
                />
                <FormControl sx={{ width: 200 }} variant="outlined" size="small">
                    <InputLabel shrink id="account-label">
                        Account
                    </InputLabel>
                    <Select
                        labelId="account-label"
                        value={selectedHandle}
                        onChange={handleHandleChange}
                        displayEmpty
                        label="Account"
                    >
                        {handles.map((h) => (
                            <MenuItem key={h.creator_handle_id} value={h.creator_handle_id}>
                                {getPlatformIcon(h.creator_handler_type)} {h.creator_handle_name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Box>

            <Grid container spacing={3} pb={3}>
                <Grid item xs={12} md={8}>
                    <Box sx={{ backgroundColor: "#fff", p: 3, borderRadius: 2, mb: 2 }}>
                        <Box sx={{ display: "flex", gap: 2 }}>
                            <Avatar src={applicationData?.creator_logo} sx={{ width: 81, height: 81 }} />
                            <Box>
                                <Box display="flex" gap={2}>
                                    <Typography variant="h6" sx={{ fontSize: '14px', color: '#1A1A1A', fontWeight: 600 }}>
                                        {applicationData?.creator_handle_name}
                                    </Typography>
                                    {applicationData?.creator_type && (<ReusableChip
                                        label={applicationData?.creator_type}
                                        size="small"
                                        sx={{
                                            border: '1px solid #ED3237',
                                            color: '#ED3237',
                                            fontSize: '11px',
                                            borderRadius: '4px',
                                            backgroundColor: '#ffffff !important',
                                        }}
                                    />)}
                                </Box>
                                <Typography variant="body2" sx={{ color: "#666" }}>
                                    {applicationData?.location}
                                </Typography>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                    {(() => {
                                        let iconName;
                                        const type = applicationData?.creator_handler_type?.toLowerCase();
                                        if (type === 'instagram') {
                                            iconName = "insta";
                                        }
                                        else if (type === 'youtube') {
                                            iconName = 'youtube';
                                        } else if (type === 'facebook') {
                                            iconName = 'facebook';
                                        }
                                        return (
                                            <>
                                                <ReusableMuiIcons name={iconName} sx={{ fontSize: 18 }} />
                                                <Typography variant="body2" sx={{ color: "#72E128" }}>
                                                    {formatFollowers(applicationData?.followers) || 0}
                                                </Typography>
                                            </>
                                        );
                                    })()}
                                </Box>
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                    {/* <Rating value={Number(applicationData?.creator_handle_rating ?? 0)} readOnly precision={0.1} /> */}
                                    <Rating value={Number(handleRating)} readOnly precision={0.1} />
                                </Box>
                            </Box>
                        </Box>
                        {niches.length > 0 && (
                            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 2 }}>
                                {visibleNiches.map((niche, index) => (
                                    <ReusableChip key={index} label={niche} size="small" />
                                ))}

                                {hiddenNiches.length > 0 && (
                                    <Tooltip
                                        arrow
                                        placement="bottom"
                                        title={
                                            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, p: 1 }}>
                                                {hiddenNiches.map((niche, index) => (
                                                    <Typography key={index} variant="body2">{niche}</Typography>
                                                ))}
                                            </Box>
                                        }
                                    >
                                        <Box sx={{ display: "inline-flex" }}>
                                            <ReusableChip
                                                label={`+${hiddenNiches.length}`}
                                                size="small"
                                                sx={{ cursor: "pointer" }}
                                            />
                                        </Box>
                                    </Tooltip>
                                )}
                            </Box>
                        )}
                    </Box>

                    <Box>
                        {applicationData?.closed === true && closeMessage()}
                    </Box>

                    <Box>
                        {applicationData?.status === "Rejected" &&
                            rejectMessage("Pitch", applicationData?.rejection_reasons, applicationData?.other_message)
                        }
                    </Box>

                    <Box>
                        {applicationData?.deliverables_links?.[0]?.child?.deliverable_status === "Rejected" && rejectMessage("Deliverable", applicationData?.deliverables_links?.[0]?.child?.deliverable_reason, "")}
                    </Box>
                    <Box>
                        {applicationData?.live_links?.some(l => l?.child?.link_status === "Rejected") &&
                            rejectMessage("Live Post", "Your live post was rejected due to policy violation.", "")}
                    </Box>

                    <CustomTabs
                        tabs={tabs}
                        activeTab={activeTab}
                        onTabChange={handleTabChange}
                        tabLabels={tabLabels}
                        arrow={true}
                        enabledTabs={enabledTabs}
                        disabledReasons={disabledReasons}
                    />
                    <Box p={1}>
                        <TabsApplicationData
                            activeTab={activeTab}
                            applicationData={applicationData}
                            setApplicationData={setApplicationData}
                            trackingLink={trackingLink}
                            setTrackingLink={setTrackingLink}
                            selectedShippingStatus={selectedShippingStatus}
                            setSelectedShippingStatus={setSelectedShippingStatus}
                            handleShippingStatusChange={handleShippingStatusChange}
                            handleShippingSubmit={handleShippingSubmit}
                            handleApprovePitch={handleApprovePitch}
                            handleRejectPitch={handleRejectPitch}
                            handleApproveDeliverable={handleApproveDeliverable}
                            handleRejectDeliverable={handleRejectDeliverable}
                            handleRequestChangesClick={handleRequestChangesClick}
                            handleSendFeedback={handleSendFeedback}
                            showFeedbackBox={showFeedbackBox}
                            setShowFeedbackBox={setShowFeedbackBox}
                            feedbackText={feedbackText}
                            setFeedbackText={setFeedbackText}
                            feedbackSentIndexes={feedbackSentIndexes}
                            expandedIndexes={expandedIndexes}
                            toggleExpand={toggleExpand}
                            submittedFeedbackTexts={submittedFeedbackTexts}
                            formatDateTime={formatDateTime}
                            isValidMap={isValidMap}
                            setIsValidMap={setIsValidMap}
                            reasonMap={reasonMap}
                            setReasonMap={setReasonMap}
                            activeTabs={activeTabs}
                            setActiveTabs={setActiveTabs}
                            handleSave={handleSave}
                            loadingMap={loadingMap}
                            loading={loading}
                            showRejectFeedbackBox={showRejectFeedbackBox}
                            setShowRejectFeedbackBox={setShowRejectFeedbackBox}
                            rejectFeedbackText={rejectFeedbackText}
                            setRejectFeedbackText={setRejectFeedbackText}
                        />
                    </Box>
                </Grid>

                <Grid item xs={12} md={4}>
                    <Box sx={{ backgroundColor: "#fff", p: 3, borderRadius: 2, boxShadow: 1 }}>
                        <Typography sx={{ color: "#7A7A7A", fontWeight: 600, mb: 1, fontSize: '18px' }}>
                            Status Summary
                        </Typography>
                        {["Pitch", "Shipping", "Deliverables", "Live Post"].map((label, i) => {
                            const statusMap = {
                                "Pitch": applicationData?.status,
                                "Shipping": applicationData?.shipping_status,
                                "Deliverables": applicationData?.deliverables_status,
                                "Live Post": applicationData?.live_status
                            };
                            return (
                                <Box key={i} sx={{ display: "flex", justifyContent: "space-between", mb: 1.5 }}>
                                    <Typography sx={{ color: "#7A7A7A", fontSize: '16px' }}>{label}:</Typography>
                                    <ReusableChip label={statusMap[label] || "Pending"} />
                                </Box>
                            );
                        })}

                        <Divider sx={{ my: 2 }} />
                        <ReusableButton
                            fullWidth
                            variant="contained"
                            classNames={!canBeClosed || applicationData?.closed === true ? "gn-actionbtn-disabled" : "gn-actionbtn"}
                            sx={{
                                textTransform: "none",
                                borderColor: "#ccc",
                                color: "#fff",
                                mt: 2,
                                cursor: !canBeClosed || applicationData?.closed === true ? "not-allowed" : "pointer",
                            }}
                            onClick={handleMarkAsClosed}
                            disabled={!canBeClosed || applicationData?.closed === true || loading.markAsClosed}
                            loader={loading.markAsClosed}
                        >
                            <Box display="flex" alignItems="center" gap={1}>
                                <ReusableMuiIcons name="done" />
                                Mark as Closed
                            </Box>
                        </ReusableButton>

                    </Box>

                    {(applicationData?.closed === false && applicationData?.live_status !== 'Approved' && applicationData?.live_status !== 'Rejected') && (<Box sx={{ backgroundColor: "#fff", p: 3, borderRadius: 2, mt: 2, mb: 2 }}>
                        <Typography sx={{ color: "#7A7A7A", fontWeight: 600, mb: 1, fontSize: '18px' }}>
                            Rate This Influencer
                        </Typography>
                        <Typography variant="body2" sx={{ color: "#999" }}>
                            Rating will be available after live post are approved.
                        </Typography>
                    </Box>)}
                    {(applicationData?.closed === true || applicationData?.live_status === 'Approved' || applicationData?.live_status === 'Rejected') &&
                        <Box mt={2}><BrandRatingPage applicationData={applicationData} /></Box>
                    }
                </Grid>
            </Grid>
        </Box>
    );
}